export default "<p>base-card works!</p>\r\n";